<template>
  <SfDropdownMultiselect
    v-model="authors"
    data-testid="authors-filter-dropdown"
    :options="options"
    dropdown-id="authorsDropdownFilter"
    :placeholder="I18n.t('inbox.filters.authors.search_placeholder')"
    :trigger-label="I18n.t('inbox.filters.trigger_labels.authors')"
  >
    <template #before>
      <SfDropdownItem
        class="tw-leading-3"
        :has-checkmark="authors.length === 0"
        :has-border="false"
        :class="{ 'tw-font-medium': authors.length === 0 }"
        @click="clearSelected"
      >
        {{ I18n.t('inbox.filters.note_types.labels.any') }}
      </SfDropdownItem>
    </template>
  </SfDropdownMultiselect>
</template>

<script setup lang="ts">
import { useInboxFiltersStore } from '../store/inbox-filters'
import SfDropdownMultiselect from '@app/shared/vue/components/sf-dropdown/sf-dropdown-multiselect.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { storeToRefs } from 'pinia'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import type { OptionGroup } from '@app/shared/vue/components/sf-dropdown/types'

interface Props {
  options: OptionGroup[]
}

defineProps<Props>()

const I18n = useI18n()
const inboxFiltersStore = useInboxFiltersStore()
const { authors } = storeToRefs(inboxFiltersStore)

function clearSelected(): void {
  authors.value = []
}
</script>
